module.exports = __webpack_public_path__ + "static/media/people-using-computer.444d0de4.jpg";